/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Help_TitleInputs */

const en_contact_aside_help_title = /** @type {(inputs: Contact_Aside_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quicker in the help centre`)
};

const pl_contact_aside_help_title = /** @type {(inputs: Contact_Aside_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybciej w centrum pomocy`)
};

/**
* | output |
* | --- |
* | "Quicker in the help centre" |
*
* @param {Contact_Aside_Help_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_help_title = /** @type {((inputs?: Contact_Aside_Help_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Help_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_help_title(inputs)
	return en_contact_aside_help_title(inputs)
});